import React from "react";
import { Button } from "react-bootstrap";
import { UseFormReturn, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import EmptyData from "go-core/components/EmptyData";
import { useWindowSize } from "go-core/components/useWindowSize";
import { ReactComponent as RemoveSVG } from "go-core/images/svg/actions/remove.svg";
import { LoanApi, LoanItemApi } from "../../../../services/Api/types";

interface Props {
	form: UseFormReturn<LoanApi>;
	loan: LoanApi;
}

const LoanItemsTable = (props: Props) => {
	const { t } = useTranslation("admin");
	const {
		control,
		register,
		formState: { errors },
	} = props.form;
	const { fields, remove, append } = useFieldArray({
		control,
		name: "items",
		keyName: "key",
	});
	const isMobile = useWindowSize().isMobile;

	return (
		<fieldset className={"form-group mt-3"}>
			<h5>{t("modules.loan.field.devices.title")}</h5>
			{fields.length > 0 ? (
				<>
					<div className={`${isMobile ? "table-responsive" : ""}`}>
						<table className={"table table-form"}>
							<thead>
								<tr>
									<th className={"action"} />
									<th>{t("lib:common.word.name")}</th>
									<th>{t("modules.loan.field.serial_id.title")}</th>
									<th className={"action"} />
								</tr>
							</thead>
							<tbody>
								{fields.map((loanItem, index) => {
									return (
										<tr key={fields[index].key}>
											<td className={"action"} />
											<td>
												<FormInput
													defaultValue={loanItem.name}
													errors={errors}
													name={`items[${index}].name`}
													register={register}
												/>
											</td>
											<td>
												<FormInput
													defaultValue={loanItem.serial_id}
													errors={errors}
													name={`items[${index}].serial_id`}
													register={register}
												/>
											</td>
											<td className={"action"}>
												{props.loan.status === "DRAFT" && (
													<RemoveSVG onClick={() => remove(index)} />
												)}
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
					<Button
						variant={"add"}
						disabled={props.loan.status !== "DRAFT"}
						onClick={() => append({} as LoanItemApi)}
					>{`+${t("common.action.add", { ns: "lib" })}`}</Button>
				</>
			) : (
				<EmptyData
					title={t("modules.loan.field.no_devices.title")}
					actions={[
						{
							name: `+${t("common.action.add", { ns: "lib" })}`,
							variant: "add",
							click: () => append({} as LoanItemApi),
						},
					]}
					styles={{ background: "#F5F8FA", marginBottom: "10px" }}
				/>
			)}
		</fieldset>
	);
};
export default LoanItemsTable;
